module.exports = __webpack_public_path__ + "img/symbol_2.860f9617.png";